import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { Card } from '@hero/components/atoms';

const GiftPreviewBox = styled.div`
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 260px;
  padding: 16px;
`;

const GiftView = styled.div`
  cursor: pointer;
  display: grid;
  flex: 1;
  grid-template-columns: 2fr;
  width: 100%;

  ${({ backgroundImage }) => css`
    background: url(${backgroundImage}) 10% 10%;
  `}
`;

const Bow = styled.div`
  grid-column-start: 1;
  grid-row-start: 1;
  height: 100%;
  width: 100%;

  ${({ theme }) => css`
    background-image: url(${theme.images.giftPreviewBoxBow});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  `}
`;

const PreviewButton = styled(Button)`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-default);
  border-radius: var(--radius-m);
  color: var(--color-accent-secondary-default);
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;
  grid-column-start: 1;
  grid-row-start: 1;
  height: max-content;
  letter-spacing: 0.15px;
  line-height: 150%;
  margin: auto;
  padding: 16px 32px;
  width: max-content;
`;

const DigitalCard = styled(Card)`
  grid-column-start: 1;
  grid-row-start: 1;
  margin: auto;
  padding: 4px;
  width: 128px;
`;

export { Bow, DigitalCard, GiftPreviewBox, GiftView, PreviewButton };
